import { render, staticRenderFns } from "./PurchaseInformationCard.vue?vue&type=template&id=27a9b5e9&"
import script from "./PurchaseInformationCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports